import './App.css';
import { useState, useEffect } from 'react';
import { CssBaseline, Box, CircularProgress } from '@mui/material';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import LoginPage from './pages/LoginPage/LoginPage';
import { SnackbarProvider } from './context/Snackbar/SnackbarContext';
import {
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { JoyTheme, materialTheme } from './config/Theme';
import { OTCPage } from './pages/OTC/OTCPage';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DanelPage } from './pages/DanelPage/DanelPage';
import DanelConfigurationPage from './pages/DataFeedConfiguration/DanelConfigurationPage';
import { DataFeedConfigurationPage } from './pages/DataFeedConfiguration/DataFeedConfigurationPage';
import DatabasePage from './pages/Database/DatabasePage';
import { DataFeedNewPage } from './pages/DataFeedNew/DataFeedNewPage';
import { DataFeedWizardPage } from './pages/DataFeedWizard/DataFeedWizardPage';
import { FlowsAutomationsPage } from './pages/FlowsAutomations/FlowsAutomationsPage';
import { useAuth } from './store/authStore';

function App() {
  // ! not sure needed all this
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const { isAuthenticated, initializeAuth } = useAuth();

  useEffect(() => {
    const init = async () => {
      // Initialize authentication from stored token
      await initializeAuth();
      setIsConfigLoaded(true);
    };

    init();
  }, [initializeAuth]);

  const [sidebarOpen, setSidebarOpen] = useState(true);

  if (!isConfigLoaded) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Router>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
          <JoyCssVarsProvider defaultMode="light" theme={JoyTheme}>
            <SnackbarProvider>
              <CssBaseline />
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/*"
                  element={
                    isAuthenticated ? (
                      <Box
                        sx={{
                          display: 'flex',
                          backgroundColor: '#f5f5f7',
                          minHeight: '100vh',
                          width: '100%',
                        }}
                      >
                        <Sidebar
                          open={sidebarOpen}
                          toggleSidebar={toggleSidebar}
                        />
                        <Box
                          component="main"
                          sx={{
                            height: '100vh',
                            width: '100%',
                            overflow: 'auto',
                            flexGrow: 1,
                            transition: 'margin-left 0.2s ease',
                            padding: '20px',
                          }}
                        >
                          <Routes>
                            <Route path="/otc" element={<OTCPage />} />
                            <Route
                              path="/portfolio"
                              element={<Navigate to="/database" replace />}
                            />
                            <Route path="/danel" element={<DanelPage />} />
                            <Route
                              path="/danel/config"
                              element={<DanelConfigurationPage />}
                            />
                            <Route
                              path="/danel/illio-config"
                              element={<DataFeedConfigurationPage />}
                            />
                            <Route
                              path="/holdings"
                              element={<Navigate to="/database" replace />}
                            />
                            <Route
                              path="/database"
                              element={<DatabasePage />}
                            />
                            <Route
                              path="/data-feed-new"
                              element={<DataFeedNewPage />}
                            />
                            <Route
                              path="/data-feed-wizard"
                              element={<DataFeedWizardPage />}
                            />
                            <Route
                              path="/flows-automations/*"
                              element={<FlowsAutomationsPage />}
                            />
                            <Route
                              path="/"
                              element={<Navigate to="/otc" replace />}
                            />
                          </Routes>
                        </Box>
                      </Box>
                    ) : (
                      <Navigate to="/login" replace />
                    )
                  }
                />
              </Routes>
            </SnackbarProvider>
          </JoyCssVarsProvider>
        </MaterialCssVarsProvider>
      </LocalizationProvider>
    </Router>
  );
}

export default App;
